import React, { Component, PropTypes } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { setPromotion, clearPromotionsErrors } from '../actions';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import Alert from '../components/home/Alert';
import Checkbox from 'material-ui/Checkbox';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars
import DatePicker from 'material-ui/DatePicker';
import _ from 'lodash';

const propTypes = {
  dispatch: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  error: PropTypes.any,
  salesChannels: PropTypes.any,
  discounts: PropTypes.array,
  query: PropTypes.object.isRequired,
};

class PromotionNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      error: false,
      required: {
        name: null,
        description: null,
        promoCode: null,
        startDate: null,
        endDate: null,
      },
      promotion: {
        name: '',
        description: '',
        promoCode: '',
        startDate: null,
        endDate: null,
        discountId: 0,
        salesChannels: [0],
        maxUses: 0,
        useOnce: false,
        nonBuyer: false,
        disabled: false,
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.goBack();
    }
    this.setRequiredParams();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        error: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
    if (nextProps.promotion && !nextProps.error) {
      this.setState({
        alertOpen: true,
        error: false,
        alertMessage: 'Promotion saved successfully!',
      });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const promotion = this.state.promotion;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = promotion[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleDatePickerChange(e, date, target) {
    const promotion = this.state.promotion;
    promotion[target] = date;
    this.setState({
      promotion,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleSelectChange(event, index, value, t) {
    const promotion = this.state.promotion;
    if (Array.isArray(promotion[t])) {
      (promotion[t].includes(value)) ? _.pull(promotion[t], value) : promotion[t].push(value); // eslint-disable-line
    } else {
      promotion[t] = value;
    }
    this.setState({
      promotion,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleChange(e) {
    const nextState = this.state.promotion;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, e.target.value);
    }
    this.setState({
      promotions: nextState,
    });
    this.setRequiredParams();
  }
  handleSubmit() {
    this.props.dispatch(clearPromotionsErrors());
    this.props.dispatch(setPromotion(this.state.promotion));
  }
  handleCancel() {
    this.props.dispatch(clearPromotionsErrors());
    browserHistory.push('/promotions?page=1');
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    if (!this.state.error) {
      browserHistory.push('/promotions?page=1');
    }
  }
  render() {
    const isTrue = true;
    const salesChannels = this.state.promotion.salesChannels;
    const discountSelect = _.map(this.props.discounts, c => <MenuItem value={c.id} key={c.id} primaryText={c.name} />);
    const scSelect = _.map(this.props.salesChannels, sc => <MenuItem
      value={sc.id}
      key={sc.id}
      label={sc.name}
      primaryText={sc.name}
      checked={salesChannels && salesChannels.includes(sc.id)}
    />);
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      datePickerStyle: {
        marginRight: '2%',
        width: '250px',
        float: 'left',
      },
    };
    return (
      <div className="sales-channels component" style={authPage}>
        <h2>New Promotion</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ margin: '20px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleSubmit}
            />
          </div>
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.promotion.name || ''}
            name="name"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.name}
            errorStyle={{ color: cyan500 }}
          />
          <TextField
            floatingLabelText="Description"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.promotion.description || ''}
            name="description"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.description}
            errorStyle={{ color: cyan500 }}
          />
          <TextField
            floatingLabelText="Promotion Code"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.promotion.promoCode || ''}
            name="promoCode"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.promoCode}
            errorStyle={{ color: cyan500 }}
          />
          <TextField
            floatingLabelText="Maximum Uses"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.promotion.maxUses || ''}
            name="maxUses"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <div id="datePickerWrapper">
            <DatePicker
              floatingLabelText="Start Date"
              mode="landscape"
              floatingLabelStyle={styles.floatingLabelStyle}
              hintText="Start Date"
              value={(this.state.promotion.startDate) ? new Date(this.state.promotion.startDate) : null}
              autoOk={isTrue}
              name="startDate"
              onChange={(e, date) => this.handleDatePickerChange(e, date, 'startDate')}
              style={styles.datePickerStyle}
              errorText={this.state.required.startDate}
              errorStyle={{ color: cyan500 }}
            />
            <DatePicker
              floatingLabelText="End Date"
              mode="landscape"
              floatingLabelStyle={styles.floatingLabelStyle}
              hintText="End Date"
              value={(this.state.promotion.endDate) ? new Date(this.state.promotion.endDate) : null}
              autoOk={isTrue}
              name="endDate"
              onChange={(e, date) => this.handleDatePickerChange(e, date, 'endDate')}
              style={styles.datePickerStyle}
              errorText={this.state.required.endDate}
              errorStyle={{ color: cyan500 }}
            />
            <SelectField
              value={this.state.promotion.discountId || ''}
              onChange={(event, index, value) => this.handleSelectChange(event, index, value, 'discountId')}
              floatingLabelText="Discount"
              style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
              name="discountId"
              floatingLabelStyle={styles.floatingLabelStyle}
            >
              {discountSelect}
            </SelectField>
            <SelectField
              value={salesChannels || []}
              multiple={isTrue}
              onChange={(event, index, values) => this.handleSelectChange(event, index, values, 'salesChannels')}
              floatingLabelText="Sales Channels"
              style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
              name="salesChannels"
              floatingLabelStyle={styles.floatingLabelStyle}
            >
              <MenuItem checked={isTrue} value={0} key={0} primaryText="All Sales Channels" />
              {scSelect}
            </SelectField>
          </div>
          <br />
          <br />
          <br />
          <br />
          <ul>
            <li>
              <Checkbox
                label="Disabled"
                defaultChecked={this.state.promotion.disabled}
                name="disabled"
                onCheck={this.handleChange}
              />
            </li>
            <li>
              <Checkbox
                label="One use limit"
                defaultChecked={this.state.promotion.useOnce}
                name="useOnce"
                onCheck={this.handleChange}
              />
            </li>
            <li>
              <Checkbox
                label="Non buyer"
                defaultChecked={this.state.promotion.nonBuyer}
                name="nonBuyer"
                onCheck={this.handleChange}
              />
            </li>
            <li>
            <Checkbox
              label="Free Shipping"
              defaultChecked={this.state.promotion.freeShipping}
              name="freeShipping"
              onCheck={this.handleChange}
            />
          </li>
          </ul>
        </div>
      </div>
    );
  }
}

PromotionNewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

PromotionNewPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    error: state.promotions.error,
    promotion: state.promotions.promotion,
    discounts: state.discounts.results,
    salesChannels: state.salesChannels.results,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(PromotionNewPage));



// WEBPACK FOOTER //
// ./src/containers/PromotionNewPage.js